import '@polymer/polymer/lib/elements/custom-style.js';

// Import shared styles as a string (Polymer requires plain CSS)
import { sharedStyles } from '@cbar/shared-styles';

const $_documentContainer = document.createElement('template');
$_documentContainer.setAttribute('style', 'display: none;');

$_documentContainer.innerHTML = `
<dom-module id="cbar-shared-styles">
    <template>
        <style>
            ${sharedStyles}

            :host {
                /* Polymer mix-ins for backwards compatibility */
                --cbar-header-app-drawer-toolbar: {
                    color: var(--cbar-header-app-drawer-on-toolbar);
                    background-color: var(--cbar-header-app-drawer-toolbar);
                };

                --paper-input-container-underline-focus: {
                    border-color: var(--paper-input-container-underline-focus-border);
                };
            }
        </style>
    </template>
</dom-module>
`;

document.head.appendChild($_documentContainer.content);
